import { render, staticRenderFns } from "./singleAdministration.vue?vue&type=template&id=a7ccbcd2"
import script from "./singleAdministration.vue?vue&type=script&lang=js"
export * from "./singleAdministration.vue?vue&type=script&lang=js"
import style0 from "./singleAdministration.vue?vue&type=style&index=0&id=a7ccbcd2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports